import React from "react";
import { generatePath, useNavigate, useSearchParams } from "react-router-dom";
import { RedirectQueryParam, Route } from "../../../../shared/enums/Redirect";
import { useAuth } from "../../../../shared/context/auth";
import { useImplicitLogin } from "../../../../shared/components/login/dataloader";
import { MyExpRoute } from "../../routes/types";
import { Base64Util } from "shared/utils/base64";
import { ProgramType } from "../../../../shared/enums/ProgramType";

export default function HandleMyExperienceRedirects() {
  const navigate = useNavigate();
  const [searchParam] = useSearchParams();
  const auth = useAuth();
  const { mutateAsync: runImplicitLogin } = useImplicitLogin();

  const loginAndNavigate = React.useCallback(
    async ({ token, path }) => {
      if (token) {
        try {
          const data = await runImplicitLogin(token);
          auth.login(data);
          navigate(path);
        } catch (e) {
          auth.logout();
          navigate(MyExpRoute.LOGIN.path);
        }
      }
    },
    [auth, navigate, runImplicitLogin]
  );

  React.useEffect(() => {
    (async () => {
      if (!searchParam.get(RedirectQueryParam.ROUTE)) {
        return;
      }
      const token = searchParam.get(RedirectQueryParam.TOKEN);
      switch (searchParam.get(RedirectQueryParam.ROUTE)) {
        case Route.LOGIN:
          await loginAndNavigate({ token, path: MyExpRoute.HOME.path });
          return;
        case Route.SHARE_ON_SOCIAL_MEDIA:
          await loginAndNavigate({ token, path: `/${MyExpRoute.SOCIAL_MEDIA_SHARE.path}` });
          return;
        case Route.PROFILE:
          const programParticipantId = searchParam.get(RedirectQueryParam.PROGRAM_PARTICIPANT_ID);
          const programType: ProgramType = searchParam.get(RedirectQueryParam.PROGRAM_TYPE) as ProgramType;
          const path =
            programType === ProgramType.TABLETALK_PROGRAM ? MyExpRoute.TABLETALK_PROFILE.path : MyExpRoute.PROFILE.path;
          const urlToNavigate = generatePath(path, { programParticipantId: programParticipantId || "" });
          await loginAndNavigate({ token, path: `/${urlToNavigate}` });
          return;
        case Route.AGENDA_PARTICIPATION_INVITE: {
          const status = searchParam.get(RedirectQueryParam.STATUS) ?? "";
          const programParticipationId = searchParam.get(RedirectQueryParam.PROGRAM_PARTICIPANT_ID) ?? "";
          const urlToNavigate = generatePath(MyExpRoute.AGENDA_PARTICIPATION_INVITE.path, {
            programParticipationId: Base64Util.decode(programParticipationId),
            status: Base64Util.decode(status)
          });
          await loginAndNavigate({ token, path: urlToNavigate });
          return;
        }
        case Route.STRIPE_STATUS:
          navigate({ pathname: MyExpRoute.PAYMENT_STATUS.path, search: searchParam.toString() });
          return;
        default:
          navigate(MyExpRoute.HOME.path);
      }
    })();
  }, [navigate, searchParam, loginAndNavigate]);

  return (
    <React.Fragment>
      <h1>Redirecting ...</h1>
    </React.Fragment>
  );
}
